module.exports = __webpack_public_path__ + "img/ma.f4f6cc1d.jpeg";